import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { MatDialog } from '@angular/material/dialog';
import { IIncidents } from 'src/app/models/incident';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UserRegDetails } from 'src/app/models/user';
import { MatTabGroup } from '@angular/material/tabs';
import { HttpClient } from '@angular/common/http';
import { IAssets } from 'src/app/models/assets';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import { environment } from 'src/app/environments/environments';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';
import { map, Observable, startWith, Subject, tap } from 'rxjs';
import { WebcamImage } from 'ngx-webcam';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-incident-dashboard',
  templateUrl: './incident-dashboard.component.html',
  styleUrls: ['./incident-dashboard.component.scss'],
})
export class IncidentDashboardComponent implements OnInit {
  isNative: boolean;
  @Input() set dashboardData(val: IDashboardState) {
    if (val) this.setDashboardData(val);
  }
  @Input() set isNotRegularFlow(val: boolean) {
    this.isCloseDisplay = val;
  }
  @ViewChild('CreateManualEventDialog', { static: true })
  createManualEventDialog: TemplateRef<any>;
  @ViewChild('RefreshingIncident', { static: true })
  refreshingIncident: TemplateRef<any>;
  @ViewChild('incidentTabs') incidentTabs: MatTabGroup;
  eventEvidence: any = '';
  currentTab: number = 0;
  isCloseDisplay = false;
  timeNow = Date.now();
  incidentData: IDashboardState;
  incidentGraphData: any;
  incidentDetails: IIncidents;
  securityCallbackIncidents: IIncidents[];
  showIncidentDescription = false;
  isShowIncidentDetail = false;
  isShowIncidentTimline = false;
  isFaceIncident = false;
  isANPRIncident = false;
  filteredAdmins: UserRegDetails[] = [];
  hostFilter = new FormControl();
  isLoggedInUser = false;
  screenSize: ScreenType;
  ownerFilter = new FormControl();
  filteredUsers: Observable<IOwnerDetails[]>;
  incidentOptions: string[] = [
    'Abandoned Object',
    'ANPR Unverified',
    'ANPR Verified',
    'Claims',
    'Communication Failure',
    'Device Faulty',
    'Device Offline',
    'Electricity Incident',
    'Face Unverified',
    'Face Verified',
    'Fire',
    'General Activity',
    'Housekeeping',
    'Incident',
    'Infrastructure Damage',
    'Intrusion',
    'Link Activity',
    'Loss/Damage of Property',
    'Over Utilised Energy',
    'Plumbing Incident',
    'Possible Crime',
    'Riot/Protest',
    'Security Incident',
    'Settled Claims',
    'Suspicious Behaviour',
    'Unattended Incident',
    'Unattended SoS',
    'UncheckedOutVisitor',
    'Unidentified Person',
    'Unmonitored Asset',
    'Unmonitored logs/activity',
    'Unsettled Claims',
    'Unverified Vehicle',
    'Unverified Visitor',
    'Unauthorised/Intruded Entry',
    'Exceeded Visitor Capacity',
    'Theft/Pilferage',
    'Under Utilised Energy',

    // New incidents
    'Water Damage',
    'Structural Failure',
    'Roof Damage',
    'Glass Breakage',
    'HVAC Failure',
    'Earthquake',
    'Flood (Natural)',
    'Storm/Wind/Hail Damage',
    'Lightning Strike',
    'Wildfire',
    'Tornado/Hurricane',
    'Elevator/Escalator Malfunction',
    'Boiler or Pressure Vessel Explosion',
    'Generator or Backup Power Failure',
    'IT/Server Room Overheating or Damage',
    'Power Outage',
    'Gas Leak',
    'Water/Sewer Line Break',
    'Telecom/Internet Disruption',
    'Slip, Trip, and Fall',
    'Workplace Injury (Employee – Physical)',
    'Workplace Injury (Employee – Psychological)',
    'Visitor Injury',
    'Exposure to Hazardous Materials',
    'Fire Code Violations',
    'Contractor/3rd-party Incident',
    'Vandalism',
    'Cybersecurity Breach',
    'Trespassing/Break-in',
    'OSHA Violations',
    'Environmental Hazard',
    'Indoor Air Quality Issue',
    'Noise Pollution',
    'Hazardous Waste Spill or Leak',
    'Building Code Violations',
    'Permit/License Lapse',
    'Political Unrest/Riots Affecting Facility',
    'Regulatory Inspection Failure',
    'Health Code Violation',
    'Pandemic-related Disruption or Exposure',
    'Preventive Maintenance Missed',
    'Reactive Maintenance',
    'Inspection Failure',
    'Equipment Downtime',
    'Cleaning/Sanitation Deficiency',
    'Janitorial or Waste Management Lapse',
    'Delayed Repair Due to Vendor',
    'Defective Replacement Part',
    'Subcontractor Default',
    'Supply Chain Disruption',
    'Open Litigation/Dispute',
    'Fraudulent or Exaggerated Claim',
    'Insurance Lapse or Policy Gaps',
    'Denied Claim',
    'Subrogation Case',
    'IT – Data Loss or Corruption',
    'IT - Data Breach',
    'IT – Software Failure or Malfunction',
    'IT – Software Bug or Defect',
    'IT – Hardware Failure or Breakdown',
    'Untrained Staff Operating Equipment',
    'Emergency Exit Blocked or Malfunctioning',
    'Active Shooter or Armed Intruder Incident',
    'Bomb Threat or Suspicious Package',
    'Alarm System Malfunction',
    'Surveillance System Failure',
    'Fire Suppression System Failure',
    'Utility Misuse or Tampering',
    'Parking Lot Accident or Safety Hazard',
    'Ergonomic Injury or Musculoskeletal Claim',
    'Lockout/Tagout Procedure Violation',
    'Threshold Breach'
  ];
  currentDate: Date = new Date();
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  selectedUsersControl = new FormControl();
  reporterControl = new FormControl();
  usersTemp: string[] = [];
  filteredAssignee: UserRegDetails[] = [];
  filteredReporter: UserRegDetails[] = [];
  baseServerURL = environment.apiUrl;
  @ViewChild('phoneInput', { static: false })
  phoneInput: NgxMatIntlTelInputComponent;
  @ViewChild('phoneInput', { read: ElementRef, static: false })
  phoneInputRef: ElementRef;
  loggedUser: UserDetailsToken;

  constructor(
    private store: Store<IAumyeState>,
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngOnInit(): void {
    this.isNative = Capacitor.isNativePlatform();
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.isLoggedInUser = this.loggedUser.role.toLowerCase() === 'user';
    this.filteredAssignee == this.incidentData.orgUserList;
    this.filteredAdmins = this.incidentData.orgUserList;
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredAssignee = this.filterHosts(value);
    });
    this.reporterControl.valueChanges.subscribe((value) => {
      this.filteredReporter = this.filterHosts(value);
    });
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredAdmins = this.filterHosts(value);
    });
    this.getOwnerData();
    this.onGetCurrentLocation();
    this.incidentManualEvent.controls.eventCreatedBy.setValue(
      this.loggedUser.fullName
    );
    this.incidentManualEvent.controls.eventCreatedByUserID.setValue(
      this.loggedUser.userID
    );
    this.incidentManualEvent.controls.eventCreatedBy.disable();
    this.filteredIncidentOptions = this.incidentOptions;
    this.incidentManualEvent
      .get('incidentName')
      ?.valueChanges.subscribe((value) => {
        const val = value || '';
        this.filteredIncidentOptions = this._filterIncidentOptions(val);

        // Trigger validation on every change
        this.incidentManualEvent
          .get('incidentName')
          ?.updateValueAndValidity({ emitEvent: false });
      });
  }
  get incidentNameControl(): FormControl {
    return this.incidentManualEvent.get('incidentName') as FormControl;
  }
  currentLocation: any;
  ownerDetailsData: IOwnerDetails[] = [];
  filteredIncidentOptions: string[] = [];
  private _filterIncidentOptions(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.incidentOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  onCheckTrue(val: any) {
    this.incidentManualEvent.controls.isCheckedReporter.setValue(val.checked);
    if (!val.checked) {
      this.incidentManualEvent.controls.eventCreatedBy.enable();
      this.incidentManualEvent.controls.eventCreatedBy.setValue(
        this.loggedUser.fullName
      );
      this.incidentManualEvent.controls.eventCreatedByUserID.setValue(
        this.loggedUser.userID
      );
      this.incidentManualEvent.controls.eventCreatedBy.disable();
    } else {
      this.incidentManualEvent.controls.eventCreatedBy.enable();
    }
  }
  private optionValidator() {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
      return this.incidentOptions.includes(value)
        ? null
        : { invalidOption: true };
    };
  }
  getOwnerData() {
    // userid: string;
    // fullname: string;
    // type: number;
    // email: string;
    // mobile: string;
    // 0 -> User
    // 1 -> Employee
    // 2 -> Visitor
    this.incidentData.orgUserList.forEach((x) => {
      this.ownerDetailsData.push({
        userid: x.userId,
        fullname: x.firstname + ' ' + x.lastname,
        type: x.isEmployee ? 1 : 0,
        email: x.email,
        mobile: x.phoneNumber,
      });
    });

    this.incidentData.visitorDetails.visitorList.forEach((x) => {
      this.ownerDetailsData.push({
        userid: x.visitorID,
        fullname: x.firstName + ' ' + x.lastName,
        type: 2,
        email: x.email,
        mobile: x.phoneNumber,
      });
    });
    if (this.incidentData.OrganizationSettings.ownerLists != null) {
      this.incidentData.OrganizationSettings.ownerLists.forEach((x) => {
        this.ownerDetailsData.push({
          userid: x.ownerName,
          fullname: x.ownerName,
          type: 3,
          email: x.ownerEmail,
          mobile: x.ownerPhone,
        });
      });
    }

    // this.filteredUsers = this.ownerDetailsData;
    this.filteredUsers = this.incidentManualEvent.controls[
      'eventOwnerName'
    ].valueChanges.pipe(
      startWith(''),
      tap(() => {
        if (this.isOwnerSelected) {
          // Clear dependent fields when user types or changes the input
          this.incidentManualEvent.controls['eventOwnerEmail'].setValue('');
          this.incidentManualEvent.controls['eventOwnerPhone'].setValue('');
          this.incidentManualEvent.controls['eventOwnerType'].setValue('');
          this.incidentManualEvent.controls['eventOwnerId'].setValue('');
          this.incidentManualEvent.controls['eventOwnerHostId'].setValue('');

          this.incidentManualEvent.controls['eventOwnerEmail'].enable();
          // this.incidentManualEvent.controls['eventOwnerPhone'].disable();

          // Clear phone input visually
          if (this.phoneInput) {
            const inputElement =
              this.phoneInputRef.nativeElement.querySelector('input');
            if (inputElement) {
              inputElement.value = '';
              inputElement.disable = true;
            }
            this.phoneInput.value = null;
          }
          this.isOwnerSelected = false;
        }
      }),
      map((value: string | IOwnerDetails) =>
        typeof value === 'string'
          ? value.toLowerCase()
          : value?.fullname?.toLowerCase() || ''
      ),
      map((name) => this._filterOwners(name))
    );
  }
  private _filterOwners(name: string): IOwnerDetails[] {
    return this.ownerDetailsData.filter((owner) =>
      owner.fullname.toLowerCase().includes(name)
    );
  }

  incidentManualEvent = this.formbuilder.group({
    incidentType: ['manual', Validators.required],
    incidentName: [
      '',
      [Validators.required, this.optionValidator()], // <-- Synchronous validators
    ],
    incidentDescription: [''],
    incidentLocation: [''],
    sourceAssetId: [''],
    sourceAsset: [''],
    incidentStatus: ['0', Validators.required],
    assignedToUserId: [''],
    assignedTo: [''],
    incidentCriticality: ['', Validators.required],
    eventOwnerName: [''],
    eventOwnerEmail: ['', [Validators.email]],
    eventOwnerId: [''],
    eventOwnerHostId: [''],
    eventOwnerPhone: [''],
    eventOwnerType: [],
    eventEvidence: [''],
    eventCreatedBy: [''],
    eventCreatedByUserID: [''],
    isLocationAdded: [false],
    isCheckedReporter: [false],
    SelectedUsers: this.formbuilder.array([], Validators.required),
  });
  checked = false;
  setDashboardData(val: IDashboardState) {
    if (
      this.incidentData &&
      this.incidentData.orgUserList &&
      this.incidentData.orgUserList.length > 0
    ) {
      this.filteredAdmins = this.incidentData.orgUserList;
      this.hostFilter.valueChanges.subscribe((value) => {
        this.filteredAdmins = this.filterHosts(value);
      });
    }
    this.incidentData = val;
    this.getIncidentMetricCounts();
    this.getSecurityCallbackIncidents(val.incidentDetails.incidentList);
    if (this.incidentDetails) {
      let newincidentDetailsData =
        this.incidentData.incidentDetails.incidentList.find(
          (x) => x.incidentId == this.incidentDetails.incidentId
        );
      if (!newincidentDetailsData) {
        newincidentDetailsData = this.incidentData.complaintsTickets.find(
          (x) => x.complainId == this.incidentDetails.incidentId.toLowerCase()
        ).complainIncidentDetails;
      }
      this.incidentDetails = newincidentDetailsData;
    }
    this.incidentGraphData = {
      manualCount: val.incidentDetails.incidentGraphCounts?.manualCount ?? 0,
      autoCount: val.incidentDetails.incidentGraphCounts?.autoCount ?? 0,
    };
  }
  todaysIncident: IIncidents[] = [];
  todaysIncidentCount = 0;
  todaysOpenIncidentCount = 0;
  todaysCloseIncidentCount = 0;
  onStatusClicked(val: any) {
    console.log(val);
  }
  getIncidentMetricCounts() {
    this.todaysIncident = this.incidentData.incidentDetails.incidentList.filter(
      (x) => {
        const eventDate = new Date(x.eventCreateDate);
        const today = new Date();

        return (
          eventDate.getFullYear() === today.getFullYear() &&
          eventDate.getMonth() === today.getMonth() &&
          eventDate.getDate() === today.getDate()
        );
      }
    );
    this.todaysIncidentCount = this.todaysIncident.length;
    this.todaysOpenIncidentCount = this.todaysIncident.filter(
      (x) => x.incidentStatus == 0
    ).length;
    this.todaysCloseIncidentCount = this.todaysIncident.filter(
      (x) => x.incidentStatus == 1
    ).length;
  }
  getSecurityCallbackIncidents(val: IIncidents[]) {
    this.securityCallbackIncidents = val;
  }
  onShowVisitorDetail(val: any) {
    // this.store.dispatch(new fromDashboardActions.GetIncidentEvidence(val));
    this.incidentDetails = val;
    this.isShowIncidentDetail = true;
    this.isShowIncidentTimline = false;
    setTimeout(() => {
      const targetElement = document.querySelector(
        '.scroll-to-incident-details'
      );
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 250);
  }
  onShowTimeline(val: any) {
    this.isShowIncidentTimline = val;
    this.isFaceIncident = this.incidentDetails.isFaceMatch == 1;
    this.isANPRIncident = this.incidentDetails.isANPR == 1;
  }
  onClose() {
    this.store.dispatch(new fromDashboardActions.InitDashboard({}));
  }
  onCloseIncidentDetail() {
    this.isShowIncidentDetail = false;
    this.isShowIncidentTimline = false;
    setTimeout(() => {
      this.incidentTabs.selectedIndex = this.currentTab;
    }, 250);
  }

  onChangeSelection(val: any) {
    this.currentTab = val.index;
    this.isShowIncidentDetail = false;
    this.isShowIncidentTimline = false;
  }
  onInitCreateManualEvent() {
    this.store.dispatch(new fromDashboardActions.InitIncidentManualEvent({}));
  }
  createManualEvent() {
    // let assignee = this.incidentData.orgUserList.filter(
    //   (item) =>
    //     item.userId == this.incidentManualEvent.controls.assignedToUserId.value
    // )[0];
    if (this.incidentManualEvent.controls.sourceAssetId.value) {
      let source = this.incidentData.orgAssetList.assets.filter(
        (item) =>
          item.assetId == this.incidentManualEvent.controls.sourceAssetId.value
      )[0];
      this.incidentManualEvent.controls.sourceAsset.setValue(source.assetName);
    }
    // this.incidentManualEvent.controls.assignedTo.setValue(
    //   assignee.firstname + ' ' + assignee.lastname
    // );
    if (!this.incidentManualEvent.contains('eventCreatedBy')) {
      this.incidentManualEvent.controls.eventCreatedBy.enable();
      this.incidentManualEvent.controls.eventCreatedBy.setValue(
        this.loggedUser.fullName
      );
      this.incidentManualEvent.controls.eventCreatedByUserID.setValue(
        this.loggedUser.userID
      );
    } else {
      console.log('eventCreatedBy control does  exist');
    }
    this.store.dispatch(
      new fromDashboardActions.CreateManualIncident(
        this.incidentManualEvent.value
      )
    );
    const dialogRef = this.dialog.open(this.createManualEventDialog, {
      disableClose: true,
      data: '',
    });
  }
  onUploadEvidence(event: any) {
    this.eventEvidence = '';
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.eventEvidence = event.target.result;
        this.incidentManualEvent.controls.eventEvidence.setValue(
          this.eventEvidence
        );
        this.cdr.detectChanges();
      };
    }
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onVerifyIncident(val: any) {
    let previousStatus = this.incidentData.incidentDetails.incidentList.find(
      (x) => x.incidentId == val.incidentId
    );
    if (!previousStatus) {
      previousStatus = this.incidentData.complaintsTickets.find(
        (x) => x.complainId == val.incidentId.toLowerCase()
      ).complainIncidentDetails;
    }
    val['previousStatus'] = previousStatus.incidentStatus;
    val['incidentStatusTimeline'] = previousStatus.incidentStatusTimeline;

    this.store.dispatch(new fromDashboardActions.VerifyIncident(val));
  }
  onSnoozeIncident(val: any) {
    let previousDetails = this.incidentData.incidentDetails.incidentList.find(
      (x) => x.incidentId == val.incidentId
    );
    if (!previousDetails) {
      previousDetails = this.incidentData.complaintsTickets.find(
        (x) => x.complainId == val.incidentId.toLowerCase()
      ).complainIncidentDetails;
    }
    val['previousStatus'] = previousDetails.incidentStatus;
    val['previousAssigned'] = previousDetails.assignedTo;
    val['incidentStatusTimeline'] = previousDetails.incidentStatusTimeline;
    val['previousStatus'] = previousDetails.incidentStatus;
    val['previousAssigned'] = previousDetails.assignedTo;
    val['previousIncidentName'] = previousDetails.incidentName;
    val['previousCreatedBy'] = previousDetails.eventCreatedBy;
    val['previousIncidentType'] = previousDetails.incidentType;
    val['previousSourceAsset'] = previousDetails.sourceAsset;
    val['previousIncidentLocation'] = previousDetails.incidentLocation;
    val['previousIncidentDescription'] = previousDetails.incidentDescription;
    val['previousIncidentCriticality'] = previousDetails.incidentCriticality;
    this.store.dispatch(new fromDashboardActions.SnoozeIncident(val));
    // this.isShowIncidentDetail = false;
  }
  onRefreshIncidentData() {
    this.isShowIncidentDetail = false;
    this.dialog.open(this.refreshingIncident, {
      disableClose: true,
    });
    this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
  }
  adminSelect(val: MatAutocompleteSelectedEvent) {
    this.incidentData.orgUserList.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.incidentManualEvent.controls.assignedToUserId.setValue(
          item.userId
        );
      }
    });
  }
  isOwnerSelected = false;
  ownerSelect(selectedOwner: IOwnerDetails) {
    this.incidentManualEvent.controls['eventOwnerId'].setValue(
      selectedOwner.userid
    );
    this.incidentManualEvent.controls['eventOwnerEmail'].setValue(
      selectedOwner.email
    );
    this.incidentManualEvent.controls['eventOwnerEmail'].disable();
    this.incidentManualEvent.controls['eventOwnerName'].setValue(
      selectedOwner.fullname
    );

    this.incidentManualEvent.controls['eventOwnerPhone'].setValue(
      selectedOwner.mobile
    );
    setTimeout(() => {
      const inputEl: HTMLInputElement =
        this.phoneInputRef?.nativeElement?.querySelector('input');
      if (inputEl) {
        inputEl.value = selectedOwner.mobile;
        inputEl.dispatchEvent(new Event('input')); // To trigger binding
      }
    });
    this.cdr.detectChanges();
    const ownerType =
      selectedOwner.type === 0
        ? 'User'
        : selectedOwner.type === 1
        ? 'Employee'
        : selectedOwner.type === 3
        ? 'New'
        : 'Visitor';
    this.incidentManualEvent.controls['eventOwnerType'].setValue(ownerType);

    if (selectedOwner.type === 2) {
      const host = this.incidentData.visitorDetails.visitorList.find(
        (x) => x.visitorID.toLowerCase() === selectedOwner.userid.toLowerCase()
      );
      if (host) {
        this.incidentManualEvent.controls['eventOwnerHostId'].setValue(
          host.hostUserId
        );
      }
    }

    this.isOwnerSelected = true;
    this.cdr.detectChanges();
  }

  filterHosts(value: string) {
    const filterValue = value.toLowerCase();
    return this.incidentData.orgUserList.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  filterOwners(value: string) {
    const filterValue = value.toLowerCase();
    return this.ownerDetailsData.filter((x) =>
      `${x.fullname}`.toLowerCase().includes(filterValue)
    );
  }
  isShowAssetFrame = false;
  src: string;
  selectedAsset: IAssets;
  onChangeSourceSelection(val: any) {
    const data = this.incidentData.orgAssetList.assets.filter(
      (x) => x.assetId === val.value
    )[0];
    this.selectedAsset = data;
    this.src = data.assetUrlPlaylist;
    this.isShowAssetFrame = true;
  }
  isFetching = false;
  takeASnapshot() {
    this.isFetching = true;

    const baseServerURL = this.baseServerURL + 'SetFrame';

    this.http
      .post(baseServerURL, this.selectedAsset, {
        responseType: 'text',
      })
      .subscribe({
        next: (res: any) => {
          try {
            const result = JSON.parse(res);
            this.eventEvidence = result.assetFrame;
            this.incidentManualEvent.controls['eventEvidence'].setValue(
              this.eventEvidence
            );
            this.isShowAssetFrame = false;
          } catch (err) {
            console.error('Failed to parse snapshot response:', err);
          }

          this.isFetching = false;
          this.cdr.detectChanges(); // Ensure UI updates
        },
        error: (err) => {
          console.error('Snapshot failed:', err);
          this.isFetching = false;
          this.cdr.detectChanges(); // Update UI on failure too
        },
      });
  }

  onPostIncidentComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
  }
  getCustomPhoneNumber(val: string): string {
    if (val && val.length > 4) {
      // Extract the last 4 digits
      const last4Digits = val.slice(-4);
      // Mask the rest of the phone number
      const maskedPart = 'xxx-xxx-';
      return maskedPart + last4Digits;
    } else {
      // Return the original value if it's too short
      return val;
    }
  }
  viewIncident: string = null;
  selectedLocations: { lat: number; lng: number }[] = [];
  markerPosition: google.maps.LatLngLiteral = {
    lat: 28.7041,
    lng: 77.1025,
  };
  center: google.maps.LatLngLiteral = { lat: 28.7041, lng: 77.1025 };
  coordinates: string = null;
  returnCoordinates: {
    coordinates: string;
    lat: any;
    lng: any;
    address: string;
  };
  response: any;
  onGetCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Store the latitude and longitude
          this.markerPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // Set the center to the current marker position
          this.center = {
            lat: this.markerPosition.lat,
            lng: this.markerPosition.lng,
          };

          // Convert the coordinates to a JSON string
          this.response = JSON.stringify(this.markerPosition);

          this.selectedLocations.push(JSON.parse(this.response));
          this.incidentManualEvent.controls['incidentLocation'].setValue(
            JSON.stringify(this.selectedLocations)
          );
          this.incidentManualEvent.controls['isLocationAdded'].setValue(true);
          this.cdr.detectChanges();

          this.getLocationAddress(this.markerPosition).subscribe(
            (response: any) => {
              if (response && response.results && response.results.length > 0) {
                const address = response.results[0].formatted_address;
                this.viewIncident = address;
                this.cdr.detectChanges();
              }
            }
          );
        },
        (error) => {
          window.alert(error.message); // Provide a meaningful error message
        }
      );
    } else {
      window.alert('Geolocation is not supported by this browser');
    }
  }
  onClickOpenMap() {
    const dialogRef = this.dialog.open(MapsLocationDialogComponent, {
      data: { header: 'Incident Location', isMultipleMarker: false },
    });
    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.selectedLocations = [];

        this.selectedLocations.push(JSON.parse(x));
        this.incidentManualEvent.controls['incidentLocation'].setValue(
          JSON.stringify(this.selectedLocations)
        );
        this.incidentManualEvent.controls['isLocationAdded'].setValue(true);
        this.cdr.detectChanges();
        this.getLocationAddress(JSON.parse(x)).subscribe((response: any) => {
          if (response && response.results && response.results.length > 0) {
            const address = response.results[0].formatted_address;
            this.viewIncident = address;
            this.cdr.detectChanges();
          }
        });
      }
    });
  }
  getLocationAddress(val: any) {
    const lat = val.lat;
    const lng = val.lng;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18'}`;

    return this.http.get(geocodeUrl);
  }
  isClickedSubmit = false;
  onGetRangeData() {
    this.dialog.open(this.refreshingIncident, {
      disableClose: true,
    });
    const data = {
      startDate: this.range.controls.start.value,
      endDate: this.range.controls.end.value,
    };
    this.store.dispatch(new fromDashboardActions.GetRangedIncidentData(data));
    this.isClickedSubmit = true;
  }
  onGetResetData() {
    this.range.reset();
    this.dialog.open(this.refreshingIncident, {
      disableClose: true,
    });
    this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
  }
  get selected() {
    return this.incidentManualEvent.get('SelectedUsers') as FormArray;
  }
  addReporter(val: MatAutocompleteSelectedEvent): void {
    const value = val.option.value;
    const matchedUser = this.incidentData.orgUserList.find(
      (user) =>
        (user.firstname + ' ' + user.lastname).toLowerCase() ===
        value.toLowerCase()
    );
    this.incidentManualEvent.controls.eventCreatedBy.setValue(
      matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim()
    );
    this.incidentManualEvent.controls.eventCreatedByUserID.setValue(
      matchedUser.userId
    );
  }
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.incidentData.orgUserList.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.incidentManualEvent.get(
      'SelectedUsers'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  isDeviceSelected = false;
  showWebcam = false;
  deviceSelected = '';
  availableDevices: any[] = [];
  private trigger: Subject<any> = new Subject();
  private nextWebcam: Subject<any> = new Subject();
  public webcamImage!: WebcamImage;
  sysImage = '';
  isCamera = false;
  get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  get nextWebcamObservable(): Observable<any> {
    return this.nextWebcam.asObservable();
  }
  captureImg(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.sysImage = webcamImage!.imageAsDataUrl;
    this.eventEvidence = this.sysImage;
    this.incidentManualEvent.controls.eventEvidence.setValue(
      this.eventEvidence
    );
  }
  onBack() {
    this.isCamera = false;
  }
  onClickOpenCamera() {
    this.isCamera = true;
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log('enumerateDevices() not supported.');
    } else {
      (async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        await navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            devices.forEach((device) => {
              if (device && device.kind === 'videoinput') {
                this.availableDevices.push(device);
              }
            });
          })
          .catch((err) => {
            console.error(`${err.name}: ${err.message}`);
          });
        stream.getTracks().forEach((track) => track.stop());
      })();
    }
  }
  getSnapshot(): void {
    this.trigger.next(void 0);
    this.showWebcam = !this.showWebcam;
  }
  onDeviceSelectChange(val: any) {
    this.isDeviceSelected = true;
    this.showNextWebcam(val);
  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
    this.showWebcam = true;
  }
  ScreenType = ScreenType;
}
interface IOwnerDetails {
  userid: string;
  fullname: string;
  type: number;
  email: string;
  mobile: string;
  // 0 -> User
  // 1 -> Employee
  // 2 -> Visitor
  // 3 -> New
}
